import styled from '@mui/material/styles/styled';
import Tab from '@mui/material/Tab';

export const StyledTab = styled(Tab)({
  minWidth: 'unset',
  minHeight: 'unset',
  padding: '2px 6px',
})